import { createAction } from '@reduxjs/toolkit';
import { AdminDiscountSortBy, DiscountFilter } from '../../../api/admin-discounts/types';

export const setAdminDiscountsKeyword = createAction<string | undefined>('SET_ADMIN_DISCOUNTS_KEYWORD');

export const setAdminDiscountsSortFilter =
  createAction<{ filter?: DiscountFilter; sort?: AdminDiscountSortBy }>('SET_ADMIN_DISCOUNTS_SORT_FILTER');

export const setSelectedDiscountsIds = createAction<number[]>('SET_SELECTED_DISCOUNTS_IDS');
